(() => {
  if (window.lasioFormulaVideosInitialized) return;
  window.lasioFormulaVideosInitialized = true;

  const initialized = new WeakSet();
  const visible = new Set();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const update = (video) => {
    if (!video.isConnected) {
      visible.delete(video);
      observer.unobserve(video);
      return;
    }
    if (document.hidden || !visible.has(video) || reducedMotion.matches) {
      video.pause();
    } else {
      video.play().catch(() => {});
    }
  };
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      if (isIntersecting) visible.add(target);
      else visible.delete(target);
      update(target);
    });
  }, { threshold: 0.1 });

  const initialize = () => {
    document.querySelectorAll('[data-formula-video]').forEach((video) => {
      if (initialized.has(video)) return;
      initialized.add(video);
      video.muted = true;
      observer.observe(video);
    });
  };
  reducedMotion.addEventListener('change', () => visible.forEach(update));
  document.addEventListener('visibilitychange', () => visible.forEach(update));
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-formula-video]').forEach((video) => {
      video.pause();
      visible.delete(video);
      observer.unobserve(video);
      initialized.delete(video);
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
